import { initAnimations } from './init-animations.mjs';

function isAnimationsDebugEnabled() {
    if (typeof window === 'undefined') {
        return false;
    }

    if (window.__SPEEDER_ANIMATIONS_DEBUG__ === true) {
        return true;
    }

    if (window.location?.search?.includes('animationsDebug=1')) {
        return true;
    }

    try {
        return window.localStorage?.getItem('speederAnimationsDebug') === '1';
    } catch (error) {
        return false;
    }
}

function bootstrapAnimations(root = typeof document !== 'undefined' ? document : null, options = {}) {
    if (!root) {
        return null;
    }

    const config =
        typeof window !== 'undefined' && window.__SPEEDER_ANIMATIONS_CONFIG__
            ? window.__SPEEDER_ANIMATIONS_CONFIG__
            : null;
    const debug = options.debug === true || isAnimationsDebugEnabled();
    const disableOnMobile = options.disableOnMobile === true || config?.disableOnMobile === true;
    const mobileBreakpoint = Number.isFinite(options.mobileBreakpoint)
        ? options.mobileBreakpoint
        : Number.isFinite(config?.mobileBreakpoint)
            ? config.mobileBreakpoint
            : 768;

    if (debug && typeof console !== 'undefined') {
        console.info('[speeder-animations] bootstrap', {
            readyState: root.readyState || '',
            debug: true,
        });
    }

    return initAnimations(root, {
        ...options,
        disableOnMobile,
        mobileBreakpoint,
        debug,
    });
}

export { bootstrapAnimations };
